import React from 'react';
import { ActivitiesSection } from '../components';

const Activity = () => {
  return (
    <ActivitiesSection />
  );
};

export default Activity;